import axios from 'axios'

/**
 * 用户登录
 *
 * @param {*} phone_no
 * @param {*} password
 * @param {*} company_name
 * @returns
 */
function userLogin(phone_no, password, company_name) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: '/index.php/RestAPI/TeamBoxWxapp/CustodianLogin',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          phone_no: phone_no,
          password: password,
          company_name: company_name
        }
      })
      .then(function (response) {
        console.log(response.data)
        resolve(response.data)
      })
      .catch(function (error) {
        // console.log(error)
        reject(error)
      })
  })
}

/**
 * 校验token， 分别调用正式环境和测试环境的校验接口
 *
 * @param {*} password
 * @returns
 */
async function checkToken(password) {
  let checkResult = await prodCheckToken(password);
  /*
  if (checkResult.meta.code === 200) {
    // 正式环境校验成功
    console.log('正式环境校验成功');
  }
  else {
    // 正式环境校验失败
    console.log('正式环境校验失败');
    checkResult = await testCheckToken(password);
  }
  */
  return new Promise(function (resolve, reject) {
    resolve(checkResult);
  })
}
  
/**
 * 正式服务器校验token
 * 注意：没有专用的token校验接口，于是用获取所有空间信息来校验token。这个接口属于查询类接口，应该不会对系统造成影响,
 * 并且只有ibox下有分配了空间，所以companyname写死了‘ibox’
 *
 * @param {*} password
 * @returns
 */
function prodCheckToken(password) {
  return new Promise(function (resolve, reject) {
    axios({
      method: 'post',
      url: '/index.php/RestAPI/TeamBoxWxapp/getSpaceList',
      headers: {
        'Content-Type': 'application/json',
        'companyname': 'yjyd',
        'password': password
      },
      data: {
      }
    })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        // console.log(error)
        reject(error)
      })
  })
}

/**
 * 测试服务器校验token
 * 注意：没有专用的token校验接口，于是用获取所有空间信息来校验token。这个接口属于查询类接口，应该不会对系统造成影响,
 * 并且只有ibox下有部署了空间，所以companyname写死了‘xjpt’
 *
 * @param {*} password
 * @returns
 */
function testCheckToken(password) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: '/testServer/index.php/RestAPI/TeamBoxWxapp/getSpaceList',
        headers: {
          'Content-Type': 'application/json',
          'companyname': 'xjpt',
          'password': password
        },
        data: {}
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        // console.log(error)
        reject(error)
      })
  })
}

export {
    userLogin,
    checkToken
}



//////////////////
// WEBPACK FOOTER
// ./static/js/yuLei.js
// module id = JnfH
// module chunks = 1